'use client';

import { type FC, useState, useEffect } from 'react';
import { Dialog, Flex, Text, Button, ButtonGroup, Input } from '@/_components';
import styles from './ConnectAppDialog.module.css';
import type { ConnectAppDialogProps } from './ConnectAppDialog.types';

export const ConnectAppDialog: FC<ConnectAppDialogProps> = ({
  isOpen,
  onClose,
  app,
}) => {
  const [appId, setAppId] = useState('');
  const [appSecret, setAppSecret] = useState('');

  useEffect(() => {
    if (isOpen) {
      // Reset fields when dialog opens
      setAppId('');
      setAppSecret('');
    }
  }, [isOpen]);

  if (!app) {
    return null;
  }

  const handleConnect = () => {
    // Placeholder for connection logic
    console.log(
      `Connecting ${app.name} with App ID: ${appId} and App Secret: ${appSecret}`,
    );
    onClose(); // Close dialog after attempting connection
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={`Connect your ${app.name} app`}
      isWide
    >
      <Dialog.Content>
        <Flex isColumn gap={4} className={styles.dialogContent}>
          <Text>
            To connect your app, you&apos;ll need to enter your app credentials.
            This information is stored securely and is only used to connect your
            app.
          </Text>
          <div className={styles.form}>
            <Input
              label="Username"
              value={appId}
              onChange={(e) => setAppId(e.target.value)}
              placeholder="Enter username"
            />
            <Input
              label="Password"
              type="password"
              value={appSecret}
              onChange={(e) => setAppSecret(e.target.value)}
              placeholder="Enter password"
            />
          </div>
        </Flex>
      </Dialog.Content>
      <Dialog.Footer>
        <ButtonGroup align="right">
          <Button value="Cancel" onClick={onClose} intent="secondary" />
          <Button value="Connect" onClick={handleConnect} intent="primary" />
        </ButtonGroup>
      </Dialog.Footer>
    </Dialog>
  );
};
